module.exports = __webpack_public_path__ + "static/img/flowers.589850c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/flowers.png
// module id = haC4
// module chunks = 0